module.exports = __webpack_public_path__ + "img/86.4e26cadd.jpg";